import { IParameter } from "../../models/parameter";

export const getAnswerValues = (parameter: IParameter) => {
    if (!parameter) {
        return [];
    }
    let answers: string[] = [];
    answers.push(parameter.answer1text);
    answers.push(parameter.answer2text);
    answers.push(parameter.answer3text);
    answers.push(parameter.answer4text);
    answers.push(parameter.answer5text);
    answers.push(parameter.answer6text);
    answers.push(parameter.answer7text);
    return answers;
};
